module.exports = __webpack_public_path__ + "static/img/hotbg.0b4af792.png";